export class GenerarConsultasParametrosEjecucionDTO {
    nombreParametro: string;
    valorParametro: string;
    tipoParametro: string;
}